import type { EIconNameType } from '@/core/components/ui/EIcon/EIcon.type';
import type { RouteLocationRaw } from 'vue-router';

export enum ViewMode {
  Table = 'table',
  Grid = 'grid',
}

export type BreadcrumbsItem = {
  title: string | undefined;
  icon?: EIconNameType;
  to?: RouteLocationRaw;
  loading?: boolean;
};
